export default "__VITE_ASSET__DyrfoMKV__"